import React, { useEffect, useState } from 'react';

interface WithPreviewProps {
  displayCard?: boolean;
  onPreviewChange?: (isHidden: boolean) => void;
  preview?: boolean;
  [key: string]: any; // For additional props
}

export function withPreview(WrappedComponent) {
  return function WithPreview(props: WithPreviewProps) {
    const {
      displayCard,
      onPreviewChange,
      preview,
      ...rest
    } = props;

    const [isHidden, setIsHidden] = useState(displayCard === false);

    useEffect(() => {
      setIsHidden(displayCard === false);
    }, [displayCard]);

    // If card is hidden and we're in preview mode, don't render anything
    if (isHidden && preview) {
      return null;
    }

    return (
      <div className={`position-relative h-100 ds-card-preview-${isHidden ? 'hidden' : 'visible'}`}>
        <WrappedComponent
          {...rest}
          isHidden={isHidden}
          preview={preview}
        />
      </div>
    );
  };
}
